const discussionStatuses = {
  accepted: 1,
  partialAccepted: 2,
  rejected: 3,
  pending: 4
};

export { discussionStatuses };
